export default __webpack_public_path__ + "static/lead_prices-89a12b72601ec391973ba2b1fd98d268.png";